import * as React from "react";
import { WithStyles, withStyles, createStyles } from './styles';
import { FieldErrors } from "../validation/validatableentity";

const styles = () => createStyles({

    root: {
        padding: 16,
        position: 'relative',
        width: '100%',
        backgroundColor: 'red',
    },

    message: {
        textAlign: 'center',
        color: 'yellow',
    },
});

interface Props {
    errors: FieldErrors;
}

const View = withStyles(styles)((props: Props & WithStyles<typeof styles>) => {

    const { classes, errors } = props;

    const getErrors = () => {
        //TODO: zmenit po vyreseni API rozhrani pro chyby nebo funkcr validationErrorsToEntityErrors v validatableentity.ts
        if (Array.isArray(errors.errors)) {
            return JSON.stringify(errors.errors);
        } else {
            return JSON.stringify(errors.errors);
        }
    }

    return <div className={classes.root}>
        <div className={classes.message}>{getErrors()}</div>
    </div>;
});

export {
    View as Errors
}
